import React from "react";
import { Link } from "react-router-dom";
import "../styles/Header.css";
import { useMsal } from "@azure/msal-react";

const AppHeader = () => {
  const { instance, accounts } = useMsal();

  const renderedAuth = () => {
    return (
      <button className="header-link-item" onClick={() => instance.logoutPopup()}>
        Sign Out
      </button>
    );
  };

  return (
    <div className="header">
      <div className="left-header-container">
        <Link to={`/`} className="header-link-item">
          Client Picker
        </Link>
      </div>
      <div className="right-header-container">
        {accounts.length === 0 ? "" : `Welcome ${accounts[0].name}`}
      </div>
      <div className="right-header-container">{renderedAuth()}</div>
    </div>
  );
};

export default AppHeader;
